module.exports = __webpack_public_path__ + "img/diagnosis-dialog-bg-3.15d4cdfb.png";